import { useTranslation } from "react-i18next";
import { Collections as CollectionsFeature } from "@/partner/features/collections";
import { Meta } from "@/shared/components";

export function CollectionsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("collections.pageTitle")} pageType="Partner" />
      <CollectionsFeature />
    </>
  );
}
